module.exports = new __parcel__URL__("notion-logomark-darkmode.52b7b937.svg").toString();